import React from "react";
import Markdown from 'react-markdown'
import l8n from 'l8n';

import './style.scss';

export const AuthPolicy = () => {
  if (l8n.locale !== 'ru') return null

  return (
    <div className="auth-policy">
      <Markdown linkTarget='_blank'>{l8n['policy.offer']}</Markdown>
      <span>{'•'}</span>
      <Markdown linkTarget='_blank'>{l8n['policy.agreement']}</Markdown>
      <span>{'•'}</span>
      <Markdown linkTarget='_blank'>{l8n['policy.pi']}</Markdown>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/CleanComponents/AuthPolicy/index.js